export default __webpack_public_path__ + "static/media/qr-frame.45b4ca3d0264443727267036f2ac9d4d.svg";